import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtMoney } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Plus, FileText } from "lucide-react";

const STATUS_CLS = {
  DRAFT: "bg-slate-100 text-slate-600", READY: "bg-sky-100 text-sky-700",
  SENT: "bg-indigo-100 text-indigo-700", VIEWED: "bg-violet-100 text-violet-700",
  ACCEPTED: "bg-emerald-100 text-emerald-700", DECLINED: "bg-red-100 text-red-700",
  EXPIRED: "bg-amber-100 text-amber-700",
};

export default function Proposals() {
  const [list, setList] = useState(null);
  useEffect(() => {
    api.get("/proposals").then(({ data }) => setList(data.proposals || [])).catch(() => setList([]));
  }, []);
  if (!list) return <div className="min-h-[60vh] grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10" data-testid="proposals-page">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-heading text-3xl font-bold text-slate-900">Proposals</h1>
          <p className="text-slate-500 mt-1">Build, send and track client proposals.</p>
        </div>
        <Button onClick={() => (window.location.href = "/scan")} className="bg-slate-900 hover:bg-slate-800" data-testid="proposals-new">
          <Plus className="w-4 h-4 mr-2" /> New from a scan
        </Button>
      </div>

      <div className="mt-8 space-y-2">
        {list.length === 0 && (
          <div className="rounded-xl border border-dashed border-slate-300 bg-white p-8 text-center" data-testid="proposals-empty">
            <FileText className="w-8 h-8 text-slate-300 mx-auto" />
            <p className="mt-2 text-slate-600">No proposals yet.</p>
            <p className="text-sm text-slate-400">Run a scan, open its solutions, and add fixes to a proposal.</p>
            <Link to="/scan" className="inline-block mt-3 text-indigo-600 font-medium">Start a scan →</Link>
          </div>
        )}
        {list.map((p) => (
          <Link key={p.public_id} to={`/proposals/${p.public_id}`} data-testid={`proposal-row-${p.public_id}`}
            className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4 hover:border-indigo-300 transition-colors">
            <div className="min-w-0">
              <p className="font-medium text-slate-900 truncate">{p.title}</p>
              <p className="text-xs text-slate-500">{p.business_name || "—"} · updated {(p.updated_at || "").slice(0, 10)}</p>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <span className="font-semibold text-slate-900">{fmtMoney(p?.totals?.one_time?.client_price, p?.totals?.currency)}</span>
              <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${STATUS_CLS[p.status] || STATUS_CLS.DRAFT}`}>{p.status}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
